import React from "react";
import PropTypes from "prop-types";
import TenantTable from "./TenantTable";

function TenantOverview({ tenants }) {
  return (
    <div>
      <TenantTable tenants={tenants} />
    </div>
  );
}

TenantOverview.propTypes = {
  tenants: PropTypes.array,
};

export default TenantOverview;
